import { create } from 'zustand'
import type { FFEStore } from './types'
import { createDocumentSlice, initialDocument } from './slices/documentSlice'
import { createLineItemsSlice } from './slices/lineItemsSlice'
import { createGroupsSlice } from './slices/groupsSlice'
import { createMaterialsSlice } from './slices/materialsSlice'
import { createFloorPlansSlice } from './slices/floorPlansSlice'
import { createPurchaseOrdersSlice } from './slices/purchaseOrdersSlice'
import { createSuppliersSlice } from './slices/suppliersSlice'

export const useFFEStore = create<FFEStore>((set, get, store) => ({
  saving: false,
  errorSaving: false,
  loadingEditor: true,
  isPreviewing: false,
  loadingDocument: false,
  document: initialDocument,
  loadingSuppliers: false,
  suppliers: [],
  loadingPurchaseOrders: false,
  isBulkImageDrawerOpen: false,
  imageEditorEntity: undefined,
  bulkImageUploadDrawerId: undefined,
  lineItemDetailsDrawerId: undefined,
  purchaseOrders: [],
  ...createDocumentSlice(set, get, store),
  ...createLineItemsSlice(set, get, store),
  ...createGroupsSlice(set, get, store),
  ...createMaterialsSlice(set, get, store),
  ...createFloorPlansSlice(set, get, store),
  ...createPurchaseOrdersSlice(set, get, store),
  ...createSuppliersSlice(set, get, store)
}))
